<div class="grid-container cursor-hand">
    <!-- Icon -->
    <div class="icon-background" (click)="goToSensorList()">
        <div class="icon">
            <ui-avatar shape="circle" size="small" [src]="universeId | universeImage: 'standalone'" />
        </div>
    </div>

    <!-- Number of sensors -->
    <div class="counter-number" (click)="goToSensorList()">
        <div class="vertical-center-container">
            @if (sensors.length > 0) {
                <div class="number" [ngStyle]="{ 'font-size': 'x-large' }">
                    {{ sensors.length }}
                </div>
            }
            &nbsp;
            @if (isSensorExtensive()) {
                <div class="text" [ngStyle]="{ 'font-size': 'large' }">
                    {{ 'ADVIZEO_ENTITIES.METER' | translate | pluralize: sensors.length }}
                </div>
            } @else {
                <div class="text" [ngStyle]="{ 'font-size': 'large' }">
                    {{ 'BUILDING_HOME.SENSOR' | translate | pluralize: sensors.length }}
                </div>
            }
        </div>
    </div>
</div>
